const SESSION_LOGOUT_ROLE_KEY = "sessionLogoutRole";

export const markSessionLogout = (role) => {
  if (typeof window !== "undefined") {
    window.sessionStorage.setItem(SESSION_LOGOUT_ROLE_KEY, role);
  }
};

export const getSessionLogoutRole = () => {
  if (typeof window === "undefined") return null;
  return window.sessionStorage.getItem(SESSION_LOGOUT_ROLE_KEY);
};

export const clearSessionLogout = () => {
  if (typeof window !== "undefined") {
    window.sessionStorage.removeItem(SESSION_LOGOUT_ROLE_KEY);
  }
};
